function fmtNum(n) {
  if (n == null) return '0';
  if (n < 1000) return String(n);

  return new Intl.NumberFormat('en', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 1,
  }).format(n);
}

export default fmtNum;
